import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { GiftCard } from './giftcard';
import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { Guid } from '../../../helpers/Guid';

export class InMemoryGiftCards extends InMemoryObjectBase<GiftCard> {

  protected get storeKeyName(): string {
    return 'in_memory_giftcards';
  }

  protected _createDemoItems(): GiftCard[] {
    return [
      new GiftCard('CARD1', 50.00, 'EAN13AAAAAAAA'),
      new GiftCard('CARD2', 10.00, 'EAN13AAAAAAAB'),
      new GiftCard('CARD3', 20.00, 'EAN13AAAAAAAC'),
      new GiftCard('CARD4', 100.00, 'EAN13AAAAAAAD'),
    ];
  }

  protected _FromJSON(json: string): GiftCard[] {
    return JSONUtilites.arrayFromJSON<GiftCard>(null, json, GiftCard.createFromAny);
  }

  generateNewCard(): GiftCard {
    return new GiftCard(Guid.generate(), 0, this._generateCardName());
  }

  private _generateCardName(): string {
    let cardName = this._generateRandomEan13();
    while (!this._isCardNameValid(cardName)) {
      cardName = this._generateRandomEan13();
    }

    return cardName;
  }

  private _isCardNameValid(cardName: string): boolean {
    return this.items.findIndex(x => x.name === cardName) === -1;
  }

  private _generateRandomEan13(): string {
    const possible = '0123456789ABCDEF';
    let text = '';
    for (let i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return '%E' + text + '_';
  }
}

